import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {SkeletonMode} from '@Components/ai-chat-window/lib/skeleton.types';

export interface EntityCardSkeletonProps {
  mode: SkeletonMode;
}

export type EntityCardSkeletonComponentPart = BaseComponentPart<StreamComponentType.ENTITY_CARD_SKELETON, EntityCardSkeletonProps>;

export const SKELETON_CARD_THUMBNAIL_SIZE = 80;
export const SKELETON_TEXT_LINE_HEIGHT = 16;
export const SKELETON_TITLE_LINE_WIDTH = 240;
export const SKELETON_META_LINE_WIDTH = 120;
